module.exports = __webpack_public_path__ + "media/video-y-fotografia-subacuatica_reel.a0f6d9c0.webm";